import {GET_KLASIFIKASI_ARSIP} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  detail: '',
};

export const getKlasifikasiArsipReducers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_KLASIFIKASI_ARSIP:
      return {
        ...state,
        detail: action.payload.detail,
      };
    default:
      return state;
  }
};

export default getKlasifikasiArsipReducers;
